import React, { Component } from 'react';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import authService from './api-authorization/AuthorizeService';
import { BaseComponent } from './base/BaseComponent';
import { Link } from 'react-router-dom';
import { Chart } from 'primereact/chart';
import { Toolbar } from 'primereact/toolbar';

export class HomeUtilizatorEfactura extends Component {

    constructor(props) {
        super(props);
        const today = new Date(); // azi
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(today.getDate() - 30);

        this.state = {
            pieNrFacturi: null,
            pieValoareFacturi: null,
            barTimpMediu: null,
            pieOptions: null,
            barOptions: null,
            dtStart: thirtyDaysAgo,
            dtEnd: today
        };
    }

    componentDidMount() {
        this.ruleaza();
    }

    setLoading = (show) => {
        this.setState({ loading: show });
    }

    async ruleaza() {
        this.setLoading(true);

        try {
            var result = await authService.fetchAuth(
                "Report/RunReport",
                {
                    report: { storedProcedureName: "ef_spGetDashboardUtilizator" },
                    parameters: { "StartDate": this.state.dtStart, "EndDate": this.state.dtEnd }
                }
            );

            var pieNrFacturi = {
                labels: result.map(x => x["Status"]),
                datasets: [{
                    data: result.map(x => x["NrFacturi"]),
                    backgroundColor: ['#ffc107', '#06b6d4', '#28a745', '#dc3545'],
                    hoverBackgroundColor: ['#ffe066', '#6fd4ea', '#71d88a', '#e96f77']
                }]
            };

            var pieValoareFacturi = {
                labels: result.map(x => x.Status),
                datasets: [{
                    data: result.map(x => x.ValoareTotala),
                    backgroundColor: ['#ffc107', '#06b6d4', '#28a745', '#dc3545'],
                    hoverBackgroundColor: ['#ffe066', '#6fd4ea', '#71d88a', '#e96f77']
                }]
            };

            const filtered = result.filter(x => x.TimpMediuMinute != null && (x.Status === "Aprobat" || x.Status === "Respins" || x.Status === "Procesat"));
            var barTimpMediu = {
                labels: filtered.map(x => x.Status),
                datasets: [{
                    label: 'Durata medie (ore)',
                    data: filtered.map(x => (x.TimpMediuMinute / 60).toFixed(2)),
                    backgroundColor: filtered.map(x =>
                        x.Status === "Procesat" ? "#06b6d4" : x.Status === "Aprobat" ? "#28a745" : "#dc3545"
                    ),
                    hoverBackgroundColor: filtered.map(x =>
                        x.Status === "Procesat" ? "#6fd4ea" : x.Status === "Aprobat" ? "#71d88a" : "#e96f77"
                    )
                }]
            };

            var pieOptions = {
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            font: { size: 14 },
                            usePointStyle: true
                        }
                    }
                },
            };

            var barOptions = {
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            font: { size: 14 },
                            usePointStyle: true
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const value = context.raw;
                                const h = Math.floor(value);
                                const m = Math.round((value - h) * 60);
                                return `${h}h ${m}min`;
                            }
                        }
                    }                  
                }
            };

            this.setState({ pieNrFacturi, pieValoareFacturi, barTimpMediu, pieOptions, barOptions });

        } catch (err) {
            console.error(err);
        } finally {
            this.setLoading(false);
        }

    }

    render() {
        return (
            <div className="p-grid p-fluid">
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h3><Link to="efactura/ListImportInvoice?status=procesat" style={{ 'color': '#008CBA', 'font-weight': 'bold' }}>Vezi facturi care necesita aprobare</Link></h3>                       
                        <div className="p-grid">
                            <div className="p-col-12 p-md-2">
                                <span className="p-float-label mt-2">
                                    <Calendar id="dtStart" dateFormat="dd.mm.yy" value={this.state.dtStart} onChange={(e) => this.setState({ dtStart: e.value })} showIcon />
                                    <label htmlFor="dtStart">Data inceput</label>
                                </span>
                            </div>
                            <div className="p-col-12 p-md-2">
                                <span className="p-float-label mt-2">
                                    <Calendar id="dtEnd" dateFormat="dd.mm.yy" value={this.state.dtEnd} onChange={(e) => this.setState({ dtEnd: e.value })} showIcon />
                                    <label htmlFor="dtEnd">Data sfarsit</label>
                                </span>
                            </div>
                            <div className="p-col-12 p-md-2">
                                <span className="p-float-label mt-2">
                                    <Button label="Ruleaza" icon="pi pi-refresh" className="p-button-success p-mr-2" onClick={this.ruleaza.bind(this)} />                                    
                                </span>
                            </div>
                        </div>
                        <div className="p-grid">
                            <div className="p-col 3 pr-4 pt-4">
                                <div className="box p-shadow-5 pt-2 pb-2">
                                    <div className="p-grid p-col-12 pl-4">
                                        <div className="p-col-11">
                                            <p className="pt-2 pr-1" style={{ 'color': '#008CBA', 'font-weight': 'bold', 'fontSize': '16px' }}>NUMAR FACTURI PER STATUS</p>
                                        </div>
                                    </div>
                                    <div className="p-col-12" style={{ width: '400px', height: '400px', margin: '0 auto' }}>
                                        <Chart type="pie" data={this.state.pieNrFacturi} options={this.state.pieOptions} />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col 3 pr-4 pt-4">
                                <div className="box p-shadow-5 pt-2 pb-2">
                                    <div className="p-grid p-col-12 pl-4">
                                        <div className="p-col-11">
                                            <p className="pt-2 pr-1" style={{ 'color': '#008CBA', 'font-weight': 'bold', 'fontSize': '16px' }}>VALOARE FACTURI PER STATUS</p>
                                        </div>
                                    </div>
                                    <div className="p-col-12" style={{ width: '400px', height: '400px', margin: '0 auto' }}>
                                        <Chart type="doughnut" data={this.state.pieValoareFacturi} options={this.state.pieOptions} />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col 3 pr-4 pt-4">
                                <div className="box p-shadow-5 pt-2 pb-2">
                                    <div className="p-grid p-col-12 pl-4">
                                        <div className="p-col-11">
                                            <p className="pt-2 pr-1" style={{ 'color': '#008CBA', 'font-weight': 'bold', 'fontSize': '16px' }}>DURATA MEDIE PRELUCRARE PER STATUS</p>
                                        </div>
                                    </div>
                                    <div className="p-col-12" style={{paddingTop:'100px', width: '400px', height: '400px', margin: '0 auto' }}>
                                        <Chart type="bar" data={this.state.barTimpMediu} options={this.state.barOptions} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default HomeUtilizatorEfactura;